//
//
//
//

const BASE_URL = '/tx-bnb';
const AUTH_URL = '/tx-bnb/login';
const HOME_URL = '/#';

// const BASE_URL = 'http://business.taxiongtrip.cn/tx-bnb';
// const AUTH_URL = 'http://business.taxiongtrip.cn/login';
// const HOME_URL = 'http://business.taxiongtrip.cn/#';

// const BASE_URL = 'http://127.0.0.1:2345/tx-bnb';
// const AUTH_URL = 'http://127.0.0.1:2345/login';
// const HOME_URL = 'http://127.0.0.1:2345/#';
export default{
    BASE_URL,
    AUTH_URL,
    HOME_URL
}



// WEBPACK FOOTER //
// ./src/Global.vue